import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author JiHoon Park
 * @contact jhpark@detech.co.kr
 * @date 2022-07-19
 * @brief EHP PDF View 개발
 *
 ********************************************************************/
import { Document, Page, pdfjs } from "react-pdf";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
/**
 * @brief EHP PDF View 컴포넌트
 * @param -
 * @returns react components
 */
function PdfViewer(props) {
    const pdfUrl = props.file;
    const windowSize = props.viewerSize;
    const setNumPages = props.setNumPages;
    const pageNumber = props.pageNumber;
    const setPageNumber = props.setPageNumber;
    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
        setPageNumber(1);
    }
    return (_jsx(_Fragment, { children: _jsx(Document, Object.assign({ file: pdfUrl, onLoadSuccess: onDocumentLoadSuccess }, { children: _jsx(Page, { width: windowSize.width, height: windowSize.height, pageNumber: pageNumber }) })) }));
}
export default PdfViewer;
